import RefNavbar from './RefNavbar';
import RefPricing from './RefPricing';

function Page2026Pricing() {
  return (
    <>
      <RefNavbar />
      <RefPricing />
    </>
  );
}

export default Page2026Pricing;
